export default __webpack_public_path__ + "static/media/login_cover.cd485391.webp";